import { SxProps, Theme } from '@mui/material';

import { Company } from '_lib/api/apiTypes.shim';

// TODO see if there is a cleaner way to do this that is still typed

const boxHighlight = (theme: Theme) => ({
  borderStyle: 'solid',
  borderWidth: 2,
  paddingX: 1,
  paddingY: 0.5,
  borderColor: theme.palette.grey[200]
});

const boxHighlightOk = (theme: Theme) => ({
  ...boxHighlight(theme),
  borderColor: theme.palette.success.main
});

const boxHighlightCaution = (theme: Theme) => ({
  ...boxHighlight(theme),
  borderColor: theme.palette.caution.yellow
});

const boxHighlightWarn = (theme: Theme) => ({
  ...boxHighlight(theme),
  borderColor: theme.palette.error.main
});

export const getBoxStyleForCanIncludeFee = (company: Company, theme: Theme) => {
  if (!company.callCenter.canWaiveFee && !company.callCenter.canIncludeFee) return boxHighlightWarn(theme);
  else if (company.callCenter.canIncludeFee) return boxHighlightCaution(theme);
  else return boxHighlight(theme);
};

export const getBoxStyleForCanWaiveFee = (company: Company, theme: Theme) => {
  if (!company.callCenter.canWaiveFee && !company.callCenter.canIncludeFee) return boxHighlightWarn(theme);
  else if (company.callCenter.canWaiveFee) return boxHighlightOk(theme);
  else return boxHighlight(theme);
};

const leftHighlight: SxProps<Theme> = {
  borderLeftWidth: 5,
  borderLeftStyle: 'solid',
  paddingLeft: 1
};

export const getLeftHighlightOkSx = (theme: Theme) => ({
  ...leftHighlight,
  borderColor: theme.palette.success.main
});

export const getLeftHighlightWarnSx = (theme: Theme) => ({
  ...leftHighlight,
  borderColor: theme.palette.error.main
});
